// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__U705B","addWidgetButton":"Header_addWidgetButton__18sjl","dashboardTabs":"Header_dashboardTabs__U5Zpq","active":"Header_active__1YERo"};